import { NgModule } from "@angular/core";
import { FormsModule } from '@angular/forms';
import { CommonModule } from "@angular/common";
import { SelectModule } from 'ng2-select';


import { CallCreateComponent } from "./call-create.component";

@NgModule({
    declarations: [
      CallCreateComponent
    ],
    imports: [
      FormsModule,
      CommonModule,
      SelectModule
    ]
})
export class CallCreateModule { }



// WEBPACK FOOTER //
// /app/SPA/src/app/client/call/create/call-create.module.ts